import { useMoodleNavigation } from './MoodleNavigationContext';

export function useOptionalMoodleNavigation() {
  try {
    return useMoodleNavigation();
  } catch {
    return null;
  }
}